<template>
  <section class="article-editor-card">
    <div class="editor-top">
      <div>
        <h2>内容编辑器</h2>
      </div>
    </div>

    <div class="editor-meta">
      <span>字符数：{{ characterCount }}</span>
    </div>

    <MarkdownWorkspace
      :model-value="modelValue"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </section>
</template>

<script setup>
import { computed } from 'vue'
import MarkdownWorkspace from './MarkdownWorkspace.vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const plainTextContent = computed(() =>
  (props.modelValue || '')
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/`[^`]*`/g, ' ')
    .replace(/!\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/\[[^\]]*]\([^)]*\)/g, ' ')
    .replace(/[#>*_\-\n\r]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
)

const characterCount = computed(() => plainTextContent.value.length)

</script>

<style scoped>
.article-editor-card {
  display: grid;
  gap: 18px;
  padding: 24px;
  border: 1px solid var(--line);
  border-radius: var(--radius-xl);
  background: var(--bg-panel);
}

.editor-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.eyebrow {
  margin: 0 0 8px;
  color: #9e5b3d;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.editor-top h2 {
  margin: 0;
  font-family: Georgia, "Source Han Serif SC", "Songti SC", serif;
  font-size: clamp(24px, 2vw, 32px);
  line-height: 1.16;
}

.editor-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: var(--text-subtle);
  font-size: 14px;
}

.editor-meta span {
  padding: 8px 12px;
  border-radius: 999px;
  background: var(--bg-soft);
}

@media (max-width: 1024px) {
  .editor-top {
    flex-direction: column;
  }
}
</style>
